import type * as React from 'react';
import { Button, type ButtonProps } from './button.tsx';
import { Tooltip } from './tooltip.tsx';

export type IconButtonProps = Omit<ButtonProps, 'children' | 'aria-label'> & {
  /** Required: the accessible name, also shown as the tooltip. */
  label: string;
  icon: React.ReactNode;
  tooltipSide?: 'top' | 'bottom' | 'left' | 'right';
};

/** Every icon-only button uses this, so a missing label is a type error. */
export function IconButton({ label, icon, tooltipSide, variant = 'ghost', size = 'icon', ...props }: IconButtonProps) {
  return (
    <Tooltip label={label} {...(tooltipSide ? { side: tooltipSide } : {})}>
      <Button aria-label={label} variant={variant} size={size} {...props}>
        {icon}
      </Button>
    </Tooltip>
  );
}
